
<template>  
    <!-- 财产安全 -->
    <!-- 非会员 -->
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-if="!(cvipMes.cvipstate == 1 || cvipMes.cvipstate == 10)">
        <p class="des">特权介绍：<span class="des-in">找工作担心违规收费、拖欠工资？您来举报，经济损失58赔偿，再也不担心上当受骗。财产安全有保障，让您安心找工作！</span></p>
        <p class="des">如何举报：<span class="des-in">点击职位详情页“举报”按钮，举报信息核实有效后即可获得您所损失的全额赔偿</span></p>
        <div class="ccaq-bg"><img class="ccaq-bg-img" src="../../../../assets/imgs/pri-ccaq.png"></div>
    </CvipDialog>
    <!-- 会员 -->
    <CvipDialog @btnClick="vipBuy()" @applyCompensate="applyCompensate()" @close="close()" :title="title1" :btnTxt=" btnTxt1 " v-else>
        <p class="tit">恭喜您，已获得<span  class="tit-names">财产安全险</span>特权</p>
        <p class="des"><span class="des-in">找工作担心违规收费、拖欠工资？您来举报，经济损失58赔偿，再也不担心上当受骗。财产安全有保障，让您安心找工作！</span></p>
        <div class="ccaq-bg"><img class="ccaq-bg-img" src="../../../../assets/imgs/pri-ccaq.png"></div>
    </CvipDialog>
</template>

<script>
    import { mapGetters, mapActions, Store } from 'vuex'
    import CvipDialog from "./common/CvipDialog"
    export default {
        name: 'qzywDialog',
        components: {
            CvipDialog
        },
        props:{
            vipState: { //会员状态   新版会员 || 老版会员
                default() {
                    return 0
                }
            },
            insuranceState: { //投保状态
                type: Number,
                default() {
                    return 0
                }
            }
        },
        data () {
            return {
                title: '财产安全险',
                btnTxt: '开通会员尊享特权',
                title1: '',
                btnTxt1: '',
                title2: '',
                btnTxt2: '立即投保'
            }
        },
        created () {
            window.clickLog && window.clickLog(`from=pc-cvip-qzyw-tanchuang-show-${this.cvipMes.cvipstate}-new`)
        },
        methods: {
            // 点击支付按钮
            vipBuy () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzyw-ljkt-${this.cvipMes.cvipstate}-new`)
                this.$emit("buyDialog")
            },
            //申请赔付
            applyCompensate () { 
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzyw-bxbx-${this.cvipMes.cvipstate}-new`)
                this.$emit("compensateDialog");
            },
            close () {
                window.clickLog && window.clickLog(`from=pc-cvip-tqtc-qzyw-close-${this.cvipMes.cvipstate}-new`)
                this.$emit("closeDialog")
            }
        },
        computed: mapGetters({
            cvipMes: 'cvipMes',
            rightUsed: 'rightUsed', //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
        }),
        
    }

</script>

<style lang='scss' scoped>

    .tit{
        margin-top:80px;
    }
    .ccaq-bg{
        width: 300px;  
        height: 247px;
        margin: 20px auto 0;
        overflow: hidden;
    }
    .ccaq-bg-img{
        width: 300px;
        height: 247px;
    }
    .des-in{
        font-size: 14px;
        color: #AAAAAA;
    }
    .des-use{
        width:100%;
        display:inline-block;
        text-align:center;
    }
    .tit{
        margin: 25px 0 8px;
        font-size: 24px;
        color: #333;
        line-height: 33px;
        text-align:center;
    }
    .des {
        line-height: 30px;

    }
    .des-center {
        text-align: center;
    }
    .tit-names{
        font-size: 24px;
        color: #D4B277;
        line-height: 33px;
    }

    .protect {
        margin-top: 14px;
    }
    .protect-des{
        font-size: 14px;
        color: #B89860;
        line-height: 22px;
        margin-bottom: 10px;
        .protectnum{
            width: 16px;
            height: 16px;
            display: inline-block;
            border: 1px solid #B89860;
            border-radius: 50%;
            line-height: 16px;
            text-align: center;
            margin-right: 7px;
        }
    }
    .protect-explain{
        font-size: 14px;
        color: #AAAAAA;
        line-height: 22px;
    }

</style>





// WEBPACK FOOTER //
// CcaqDialog.vue?0c586f45